<template>
  <div class="NavBar">
    <van-nav-bar
      :fixed="isFixed"
      :placeholder="placeholder"
      custom-class="custom-nav-bar"
      :title="title"
      @click-left="goBack"
    >
      <template #left>
        <van-icon v-if="lefticon" name="arrow-left" size="25" color="#000000" />
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  props: {
    title: {
      type: String,
      required: true,
      //必须传递
    },
    lefticon: {
      type: Boolean,
      default: true,
      //默认值
    },
    isFixed: {
      type: Boolean,
      default: true,
      //默认值
    },
    placeholder: {
      type: Boolean,
      default: true,
      //默认值
    },
  },
  data() {
    return {};
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1); // 返回上一页
      } else {
        this.$router.push("/aj/index"); // 跳转到指定页面
      }
    },
  },
};
</script>
<style lang="less" scoped>
.fixed {
  position: fixed;
  top: 0;
  left: 0;
}
/deep/.van-nav-bar {
  background-color: white;

  color: black !important;
}
/deep/.van-nav-bar__title {
  color: black !important;
}
/deep/.van-hairline--bottom:after {
  border-bottom-width: 0;
}
/deep/.van-nav-bar__content {
  height: 60px !important;
}
</style>
